export default "__VITE_ASSET__DxedCJ6U__"